import type { InstitutionArtwork } from "./institutionArtwork";
import { financeInstitutions } from "./institutionCatalogueFinance";
import { productInstitutions } from "./institutionCatalogueProduct";
import { providerInstitutions } from "./institutionCatalogueProviders";

/**
 * Every brand `InstitutionIcon` draws, keyed by kebab-case name. New brands
 * are added here (artwork in `icons/institutions/`), never as a raw `<img>`
 * at a call site.
 */
export const institutionCatalogue = {
    ...financeInstitutions,
    ...providerInstitutions,
    ...productInstitutions,
} satisfies Record<string, InstitutionArtwork>;

export type InstitutionKey = keyof typeof institutionCatalogue;
